.group {
  display: flex;
  width: 100%;
  min-width: 0;
  margin: 0;
  border: 0;
  padding: 0;
}

.group > :first-child {
  flex: 1;
  border-start-end-radius: 0;
  border-end-end-radius: 0;
}

.group > :last-child {
  flex: none;
  margin-inline-start: -1px;
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.group > :focus-visible {
  position: relative;
  z-index: 1;
}
